import { faro } from '@grafana/faro-react';
import { GrowthBookProvider as RootGrowthBookProvider } from '@growthbook/growthbook-react';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import getCookie from '../../../analytics/helpers/getCookie/getCookie';

const GrowthBookProvider = ({ client, children }) => {
  const featureCookie = getCookie('ri_features');

  useEffect(() => {
    // If the feature cookie exists, set it as the feature payload
    if (featureCookie) {
      if (faro?.api?.pushLog) {
        faro.api.pushLog(['Feature cookie found'], {
          level: 'info',
        });
      }
      const payload = client.getPayload();
      client.setPayload({
        ...payload,
        features: {
          ...payload.features,
          ...JSON.parse(featureCookie),
        },
      });
    }
  }, [client, featureCookie]);

  return (
    <RootGrowthBookProvider growthbook={client}>
      {children}
    </RootGrowthBookProvider>
  );
};

// Add prop types validation
GrowthBookProvider.propTypes = {
  client: PropTypes.shape({
    getPayload: PropTypes.func.isRequired,
    setPayload: PropTypes.func.isRequired,
    // add other methods or props as required!
  }).isRequired,
  children: PropTypes.node.isRequired,
};

export { GrowthBookProvider };
